import React from 'react';
import { AiOutlineRise, AiOutlineFall } from 'react-icons/ai';

const DashboardCard = ({ title, value, icon, color, percentage, trend, loading }) => {
    return (
        <div className={`bg-white rounded-xl shadow-sm p-5 hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 border-l-4 ${color} overflow-hidden relative`}>
            {loading ? (
                <div className="animate-pulse flex space-x-4">
                    <div className="flex-1 space-y-4 py-1">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-8 bg-gray-300 rounded w-1/2"></div>
                    </div>
                    <div className="rounded-full bg-gray-200 h-12 w-12"></div>
                </div>
            ) : (
                <>
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-gray-500 text-sm font-medium">{title}</p>
                            <h2 className="text-2xl font-bold mt-1 tracking-tight">{value}</h2>
                        </div>
                        <div className={`p-3 rounded-lg ${color.replace('border-', 'bg-')}/10`}>
                            {icon}
                        </div>
                    </div>
                    {percentage && (
                        <div className="mt-4 flex items-center">
                            {trend === 'up' ? 
                                <AiOutlineRise className="text-green-500 mr-1" /> : 
                                <AiOutlineFall className="text-red-500 mr-1" />}
                            <span className={percentage >= 0 ? "text-green-500 font-medium" : "text-red-500 font-medium"}>
                                {percentage >= 0 ? "+" : ""}{percentage}%
                            </span>
                            <span className="text-gray-500 text-xs ml-2">vs. last month</span>
                        </div>
                    )}
                    <div className="absolute -right-3 -bottom-3 opacity-5">
                        {icon && React.cloneElement(icon, { size: 80 })}
                    </div>
                </>
            )}
        </div>
    );
};

export default DashboardCard; 